/* База на устройстве (IndexedDB) для работы кабинета без сети — своя на аккаунт тренера.
   Три хранилища: cache — ответы API (кэш React Query), outbox — очередь неотправленных правок,
   meta — служебное (время последней синхронизации, версии дней). Недоступна (приватный режим,
   запрет сайта) — кабинет работает как раньше, только без оффлайна. */

export type Store = 'cache' | 'outbox' | 'meta';
const STORES: Store[] = ['cache', 'outbox', 'meta'];
const PREFIX = 'trenergram-trainer-';

let name = '';
let dbp: Promise<IDBDatabase | null> = Promise.resolve(null);

/** Открыть базу аккаунта; null — выйти из неё (выход из аккаунта) */
export function openDb(pid: string | null) {
  const next = pid ? PREFIX + pid : '';
  if (next === name) return dbp;
  dbp.then((db) => db?.close());
  name = next;
  dbp = !next
    ? Promise.resolve(null)
    : new Promise((res) => {
        try {
          const r = indexedDB.open(next, 1);
          r.onupgradeneeded = () => {
            for (const s of STORES) if (!r.result.objectStoreNames.contains(s)) r.result.createObjectStore(s);
          };
          r.onsuccess = () => res(r.result);
          r.onerror = () => res(null);
          r.onblocked = () => res(null);
        } catch {
          res(null);
        }
      });
  return dbp;
}

function req<T>(store: Store, mode: IDBTransactionMode, f: (s: IDBObjectStore) => IDBRequest): Promise<T | undefined> {
  return dbp.then(
    (db) =>
      new Promise<T | undefined>((res) => {
        if (!db) return res(undefined);
        try {
          const r = f(db.transaction(store, mode).objectStore(store));
          r.onsuccess = () => res(r.result as T);
          r.onerror = () => res(undefined);
        } catch {
          res(undefined);
        }
      }),
  );
}

export const idbGet = <T>(s: Store, k: IDBValidKey) => req<T>(s, 'readonly', (st) => st.get(k));
export const idbSet = (s: Store, k: IDBValidKey, v: unknown) => req(s, 'readwrite', (st) => st.put(v, k));
export const idbDel = (s: Store, k: IDBValidKey) => req(s, 'readwrite', (st) => st.delete(k));
/** Все записи хранилища по порядку ключей */
export const idbAll = <T>(s: Store) => req<T[]>(s, 'readonly', (st) => st.getAll()).then((x) => x || []);

/** Выход из аккаунта: тренировки клиентов на устройстве не оставляем */
export function dropDb(pid: string) {
  if (name === PREFIX + pid) openDb(null);
  try {
    indexedDB.deleteDatabase(PREFIX + pid);
  } catch {
    /* недоступно */
  }
}
